/*
 * @Author: liangliang
 * @Date: 2023-05-15 14:08:24
 * @LastEditors: yusha
 * @LastEditTime: 2024-02-26 15:19:45
 * @Description: 订单模块枚举
 */
import { t } from '@/plugins/i18n'
import { useRtfix } from '@/store'
export const channelEnum:any = {
  1: t('市场购'),
  2: t('透明购'),
  3: t('OEM'),
  4: t('一口价'),
  5: t('线下')
}
export const productStatsEnum:any = {
  1: t('待采购'),
  2: t('采购中'),
  3: t('已采购'),
  4: t('国内运输中'),
  5: t('已入库'),
  6: t('检品中'),
  7: t('已上架'),
  8: t('待发货'),
  9: t('已发货'),
  10: t('处理中的次品和异常'),
  11: t('不可退货次品'),
  12: t('取消成功'),
  14: t('在途'),
  13: t('保留库存'),
  15: t('待补货')
}

export const productStatsEnum2b:any = {
  1: t('待采购'),
  2: t('采购中'),
  3: t('已采购'),
  4: t('国内运输中'),
  5: t('已入库'),
  6: t('检品中'),
  7: t('已上架'),
  // 8: t('待发货'),
  // 9: t('已发货'),
  10: t('处理中的次品和异常'),
  11: t('不可退货次品'),
  12: t('取消成功')
  // 13: t('保留库存')
}

export const productStatsEnum2c:any = {
  1: t('待采购'),
  2: t('采购中'),
  3: t('已采购'),
  4: t('国内运输中'),
  5: t('已入库'),
  6: t('检品中'),
  7: t('已上架'),
  // 8: t('待发货'),
  // 9: t('已发货'),
  10: t('处理中的次品和异常'),
  11: t('不可退货次品'),
  12: t('取消成功')
//   14: t('在途')
  // 13: t('保留库存')
}

export const productDeliveryStatus:any = [
  {
    label: t('待匹配'),
    value: '15'
  },
  {
    label: t('在途'),
    value: '14'
  },
  {
    label: t('匹配良品'),
    value: '7'
  },
  {
    label: t('待发货'),
    value: '8'
  },
  {
    label: t('发货完了'),
    value: '9'
  }
]
export const combinationStatusDict: any = {
  1: t('未组合'),
  2: t('组合中'),
  3: t('组合完成'),
  4: t('取消组合')
}

export const setProdcutLink = (row: any) => {
  return (row?.channel === 1 || row?.channel === 5) ? row?.productCode ? useRtfix('goods', { params: { id: row.productCode } }) : '' : (row?.productDetailUrl || '')
}
